import React from "react";
import { MORE_LINKS } from "../data/links";
import { LinksSection } from "./links-section";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const MoreLinks = () => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });

	return (
		<LinksSection
			title={footerTexts.getText({ id: "section.community", defaultText: "Comunidad" })}
			linksData={MORE_LINKS}
		/>
	);
};
